import { ChevronDownIcon } from '@heroicons/react/16/solid';
import React from 'react';
import { cn } from '../../../lib/classNameHelpers';
import { Button } from '../../catalyst-ui-kit/button';

type TriggerWithChevronProps = {
  title?: string;
  isOpen?: boolean;
  disabled?: boolean;
} & React.HTMLProps<HTMLElement>;

/** MultiSelect trigger with chevron */
export const TriggerWithChevron = ({
  disabled,
  children,
  title,
  className,
  isOpen = false,
  color: _color,
  type: _type,
  ...props
}: TriggerWithChevronProps) => (
  <Button
    {...props}
    text
    size="xs"
    disabled={disabled}
    className={cn(
      'group flex items-center gap-1 whitespace-nowrap !p-1 !text-contentSecondary hover:!text-contentPrimary',
      { '!text-contentPrimary': isOpen },
      className
    )}
    title={title}
  >
    {children}
    <ChevronDownIcon
      className={cn(
        'size-3 shrink-0 fill-contentSecondary transition-all group-hover:fill-contentPrimary',
        {
          'rotate-180 fill-contentPrimary': isOpen,
        }
      )}
      aria-hidden="true"
    />
  </Button>
);
